import React from 'react';
import { NoticeModal as NoticeModalNew } from './NoticeModal';
import { convertOldNoticeModalProps } from './converter.old';
import type { OldNoticeModalProps } from './converter.old';

export type NoticeModalProps = OldNoticeModalProps;

export const NoticeModal = (props: React.PropsWithChildren<NoticeModalProps>) => (
  <NoticeModalNew {...convertOldNoticeModalProps(props)} />
);
